module.exports = __webpack_public_path__ + "static/bch-icon-qrcode-03037cb9814931582c7d03acdb44365e.png";